export default "__VITE_ASSET__3ed141db__"